export default __webpack_public_path__ + "static/media/Inspection.a7f6c970.png";